<script>
  import { format } from 'svelte-i18n';
  import { useNavigate } from 'svelte-navigator';
  import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { getNotificationsContext } from '@client/components/notifications';

  import { GroupsService } from '@client/services/groups';

  import { appStore } from '@client/stores/app';

  import { generateUniqueRulename } from '@client/utils/rulenames';

  export let row = {};
  export let props = {};

  const navigate = useNavigate();
  const redirect = (path) => navigate(path);

  const { addNotification } = getNotificationsContext();

  let isOpen = false;

  const notify = (text, type = 'success', autohide = 2500, position = 'top-right') => {
    addNotification({ text, type, autohide, position });
  };

  const onCloneHandler = async () => {
    $appStore.loading = true;

    const groupname = generateUniqueRulename(row.groupname);

    const payload = {
      ...row,
      _id: null,
      _newObject: true,
      groupname
    };

    const response = await GroupsService.createGroup(payload);

    $appStore.loading = false;

    if (response !== 'Empty' && response?.status >= 400) {
      notify($format('label.FAILURE.GROUP_CLONE', { values: { group: row.groupname } }), 'error');
      return;
    }

    notify($format('label.SUCCESS.GROUP_CLONE', { values: { group: row.groupname } }));

    setTimeout(() => navigate(`/manage/groups/${payload.groupname}`), 200);
  };

  const onDeleteHandler = async () => {
    const confirmed = confirm(
      $format('label.DELETE_PROMPT', { values: { type: $format('label.GROUP').toLowerCase() } })
    );

    if (confirmed) {
      $appStore.loading = true;

      const response = await GroupsService.deleteGroup(row);

      $appStore.loading = false;

      if (response?.status >= 400) {
        notify($format('label.FAILURE.GROUP_DELETE', { values: { group: row.groupname } }), 'error');
        return;
      }

      notify($format('label.SUCCESS.DELETE', { values: { type: row.groupname } }));

      props.onDelete();
    }
  };

  const onRenameHandler = () => {
    if (props.onRename) {
      props.onRename(row);
    }
  };
</script>

<span on:click|preventDefault|stopPropagation role="button" tabindex="0">
  <ButtonDropdown bind:isOpen>
    <DropdownToggle color="none" tag="span">
      <Icon name="more-vertical" class={isOpen ? 'action-icon active' : 'action-icon'} />
    </DropdownToggle>
    <DropdownMenu>
      <DropdownItem on:click={onRenameHandler}>{$format('label.RENAME')}</DropdownItem>
      <DropdownItem divider />
      <DropdownItem on:click={() => redirect(row.groupname)}>{$format('label.EDIT')}</DropdownItem>
      <DropdownItem on:click={onCloneHandler}>{$format('label.CLONE')}</DropdownItem>
      <DropdownItem divider />
      <DropdownItem disabled={row.status} on:click={onDeleteHandler}>{$format('label.DELETE')}</DropdownItem>
    </DropdownMenu>
  </ButtonDropdown>
</span>

<style lang="scss">
  i {
    border: 1px solid transparent;
    border-radius: var(--border-radius-base);
    color: var(--color-text);
    cursor: pointer;
    padding: var(--padding-small) var(--padding-xsmall);

    &.active,
    &:hover {
      background-color: var(--color-white);
      border-color: var(--color-gray-200);
    }
  }
</style>
